import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EditContactList } from './edit-contact-from-list';
import { IonicStepperModule } from 'ionic-stepper';
import { PrimaryForm } from './component/primary-applicant/primary-form/primary';
import { TextMaskModule } from 'angular2-text-mask';

import { DependentDetails } from './component/dependent-and-family/dependent-details/dependent-details';
import { AddressDetail } from './component/primary-applicant/address-detail/address-detail';
import { EmploymentDetails } from './component/employment-and-incomedetails/employment-details/employment_details';
import { IncomeDetails } from './component/employment-and-incomedetails/income-details/income_details';


@NgModule({
  declarations: [
    EditContactList,
    PrimaryForm,
    DependentDetails,
    AddressDetail,
    EmploymentDetails,
    IncomeDetails,
  ],
  imports: [
    IonicStepperModule,
    IonicPageModule.forChild(EditContactList),
    TextMaskModule
  ],
  exports:[
    EditContactList,
    PrimaryForm,
    DependentDetails,
    AddressDetail,
    EmploymentDetails,
    IncomeDetails
  ]
})
export class EditContactModule {}



// WEBPACK FOOTER //
// ./src/pages/edit-contact-form-list/edit-contact-from-list.module.ts